import React from 'react';
import PropTypes from 'prop-types';
import TeamManagementData from 'components/molecules/teammanagementdata';
import './team-management-list.scss';
import TeamManagementListSkeleton from 'components/molecules/teammanagementlistskeleton';

function TeamManagementList({
  teamMembersList,
  loading,
  fetchTeamMembersData,
  onRemoveTeamMember,
  removeMemberLoading,
  onUpdateRole,
  showInvitationVerification,
  dashboardId,
}) {
  if (loading || removeMemberLoading) {
    return <TeamManagementListSkeleton />;
  }
  return (teamMembersList?.map((list) => (
    <TeamManagementData
      key={list?.email}
      list={list}
      fetchTeamMembersData={fetchTeamMembersData}
      onRemoveTeamMember={onRemoveTeamMember}
      onUpdateRole={onUpdateRole}
      showInvitationVerification={showInvitationVerification}
      dashboardId={dashboardId}
    />
  )));
}

TeamManagementList.propTypes = {
  teamMembersList: PropTypes.arrayOf({
    email: PropTypes.string,
    name: PropTypes.string,
    userType: PropTypes.string,
    status: PropTypes.string,
    hasAccount: PropTypes.bool,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  fetchTeamMembersData: PropTypes.func.isRequired,
  onRemoveTeamMember: PropTypes.func.isRequired,
  removeMemberLoading: PropTypes.bool.isRequired,
  onUpdateRole: PropTypes.func.isRequired,
  showInvitationVerification: PropTypes.bool.isRequired,
  dashboardId: PropTypes.string.isRequired,
};

export default TeamManagementList;
